import { LitElement, html } from 'lit';
import styles from './styles';
import FormController from '../../../shared/controllers/FormController';
import '../../../shared/components/input/Input';
import '../../../shared/components/icons/IconSearch';
import { updateUrlParams } from '../../../shared/utils/helpers';

class JobBoardSearch extends LitElement {
  static styles = styles;

  static properties = {
    search: {
      type: String,
      state: true,
    },
  };

  constructor() {
    super();
    this.search = '';
  }

  connectedCallback() {
    super.connectedCallback();
  }

  form = new FormController(this, { onSubmit: (params) => this.onSubmit(params) });

  #setUrlSearchParam(value) {
    const searchParams = new URLSearchParams(window.location.search);
    const trimmedValue = value.trim();

    if (trimmedValue) {
      searchParams.set('search', trimmedValue);
    } else {
      searchParams.delete('search');
    }

    updateUrlParams(searchParams);
  }

  onChange(event) {
    event.preventDefault();
    this.#setUrlSearchParam(event?.detail?.value);

    this.dispatchEvent(
      new CustomEvent('search-event', {
        composed: true,
        bubbles: true,
        detail: {
          value: event?.detail?.value,
          srcEvent: event,
        },
      }),
    );
  }

  render() {
    return html`
      <div class="job-search-bar">
        <tenable-input type="text" name="job-search" placeholder="${this.search || 'Search'}" @input-change=${(e) => this.onChange(e)} value="${this.search}"></tenable-input>
        <tenable-icon-search class="job-board-search-icon"></tenable-icon-search>
      </div>
    `;
  }
}

customElements.define('tenable-job-board-search', JobBoardSearch);
